export default {
  // To-Do tab dialogs
  label_todo: "To-Do",
  prompt_sure: "Are you sure you want to delete ",
  title_add_todo: "Add To-Do",
  title_delete_todo: "Delete To-Do",
  title_edit_todo: "Edit To-Do item",
  title_discard_todo: "Discard all",
  content_discard_todo:
    "Are you sure you want to discard the <b>{amount}</b> To-Dos marked <b class='text-info'>DONE</b>?",
  content_discard_todo_all: "Remove ALL to-dos",

  // Unsubmitted Work tab dialogs
  title_discard_all: "Discard all",
  title_discard_selected: "Discard selected",
  title_discard_unsubmitted: "Discard Unsubmitted Work",
  content_discard_all: "Are you sure you want to discard all your unsubmitted work?",
  content_discard_selected: "Are you sure you want to discard the selected unsubmitted work?",
  content_discard_unsubmitted: "Are you sure you want to discard the unsubmitted work?",
}
